import React, { useState, useCallback } from 'react';
import { Table } from 'react-virtualized';
import 'react-virtualized/styles.css';
import { makeStyles } from '@material-ui/core/styles';
import { getComparator, stableSort } from '../../utils/sortable';
import TableHeader from './VirtTableHeader';
import { Grid } from '../../layouts';

const useStyles = makeStyles((theme) => ({
  container: {
    borderBottomColor: 'rgb(224, 224, 224)',
    borderBottomStyle: 'solid',
    borderBottomWidth: '1px'
  },
  tableCellContainer: {
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    display: '-webkit-box',
    WebkitLineClamp: 4,
    WebkitBoxOrient: 'vertical',
    fontFamily: 'Roboto, Helvetica, Arial, sans-serif',
    fontSize: '14px',
    fontWeight: 400,
    padding: '16px',
    letterSpacing: '0.15px',
    lineHeight: '20px'
  }
}));

const VirtTable = (props) => {
  const { rows, defaultOrderBy } = props;

  const classes = useStyles();

  const [order, setOrder] = useState('asc');
  const [orderBy, setOrderBy] = useState(defaultOrderBy);

  const handleRequestSort = useCallback(
    (event, property) => {
      const isAsc = orderBy === property && order === 'asc';
      setOrder(isAsc ? 'desc' : 'asc');
      setOrderBy(property);
    },
    [orderBy, order]
  );

  const items = stableSort(rows, getComparator(order, orderBy));

  const renderRow = ({ key, rowData, style }) => {
    const row = rowData;
    const rowStyle = style;
    rowStyle['flex-wrap'] = 'nowrap';
    return (
        <Grid container style={rowStyle} className={classes.container} key={key}>
          {props.columns.map((column) => (
            <Grid item xs={column.xs} key={column.id} style={{ display: 'flex', height: 96 }} align={column.align || 'left'}>
                <div className={classes.tableCellContainer} style={column.style}>
                  {row[column.id]}
                </div>
            </Grid>
          ))}
        </Grid>
    )
  };

  const renderRowHeader = ({ style }) => {
    return (
      <TableHeader style={style}
        columns={props.columns}
        order={order}
        orderBy={orderBy}
        onRequestSort={handleRequestSort}
        rowCount={rows.length}
      />
    );
  };

  return (
    <Table
      {...props}
      width={props.dimensions.width}
      height={props.dimensions.height}
      headerHeight={props.headerHeight}
      rowHeight={props.rowHeight}
      headerRowRenderer={renderRowHeader}
      rowRenderer={renderRow}
      onRowsRendered={() => { }}
      onScroll={() => { }}
      rowCount={items.length}
      rowGetter={({ index }) => items[index]}
    />
  );
}

export default VirtTable;
